(function ($) {
    $(document).ready(function () {

        // For each instance of the Social Slider.
        $.each($('.post-slider'), function () {
            let slider_id      = $(this).attr('data-block-id');
            let autoplay       = $(this).attr('data-autoplay');
            let slides_to_show = $(this).attr('data-slides-to-show'); console.log(slides_to_show);

            /**
             * Initialize the carousel.
             */
            $(this).slick({
                infinite: true,
                slidesToShow: slides_to_show,
                slidesToScroll: 1,
                autoplay: autoplay,
                pauseOnHover: autoplay,
                arrows: false,
                // centerMode: Boolean(post_overflow),
                appendDots: $('.main-slider-container'),
                responsive: [
                    {
                        breakpoint: 1120,
                        settings: {
                            slidesToShow: 3,
                        }
                    },
                    {
                        breakpoint: 992,
                        settings: {
                            slidesToShow: 2,
                        }
                    },
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 1,
                        }
                    },
                ]
            });

            /**
             * Hook up the controls.
             */
            $('.previous-button.slider-' + slider_id).click(function () {
                $('#slider-' + slider_id).slick('slickPrev');
            })

            $('.play-pause-button.slider-' + slider_id).click(function () {
                $('.pp-toggle', $(this)).toggleClass('active');

                if ($('.pp-toggle.pause', $(this)).hasClass('active')) {
                    $('#slider-' + slider_id).slick('slickPlay');
                }
                if ($('.pp-toggle.play', $(this)).hasClass('active')) {
                    $('#slider-' + slider_id).slick('slickPause');
                }
            })

            $('.next-button.slider-' + slider_id).click(function () {
                $('#slider-' + slider_id).slick('slickNext');
            })

            /**
             * Click posts to go to the post on the social media site
             */
            $.each($('.social-item'), function () {
                let socialItemLink = $(this).attr('data-link');

                $(this).on('click', function (){
                    window.open(socialItemLink, '_blank').focus();
                });
            });
        });

    });
})(jQuery);
